import { Popup } from "@/components/Popup";
import { InfoIcon } from "@/designSystemIcons";

export const TacticPopularityScorePopup = ({
  onClose,
}: {
  onClose: () => void;
}) => (
  <Popup
    title="Popularity Score"
    onClose={onClose}
    titleIcon={
      <InfoIcon innerFill="white" outerFill="var(--color-primary-blue)" />
    }
  >
    <div className="flex flex-col gap-y-8 p-4 small-mobile:p-10 min-w-90 mobile:min-w-144">
      <p className="text-dark-secondary">
        The Popularity Score gives you an idea of how much a tactic is used
        in-game. It is based on Club Import data, which makes it a perfect
        indicator for which tactics are currently preferred by FC players. The
        score is updated once every week, in order to make sure that it is
        always up-to-date with the latest meta!
      </p>
      <img
        src={
          import.meta.env.VITE_APP_ASSETS_BASE_URL +
          "/fc25/frontend-assets/tactics/popularity-score-description.png"
        }
        alt="Popularity Score"
        className="hidden desktop:block w-144 mx-auto"
      />
    </div>
  </Popup>
);
